__turbopack_context__.v({
  "className": "gothammedium_34827072-module__P6esPW__className",
});
